export default function PLANT({ children }) {
  return (
    <>
      <p>
        PLANT sees industrial design students negotiate with the physical, philosophical,
        biological, behavioural, and ideological relationship between people and (house)plants.
      </p>
      <p>
        The rise of decorative indoor planting has been phenomenal in recent years. Yet, the
        evolution of pot and planter design has largely remained stylistic, with the occasional
        technical novelty. What if a planter is not a pot? What if a planter is soft? What if a
        planter is obsessive? What if a planter is a sanctuary? Questions such as these are teased
        out in design propositions that reimagine the common household planter, challenging
        presumptions and provoking new sensibilities.
      </p>
      <p>
        These projects were completed at the Division of Industrial Design, College of Design and
        Engineering at the National University of Singapore, led by either Donn Koh or Hans Tan and
        Sheryl Teng.
      </p>
      {children}
    </>
  );
}
